'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _radio = require('./radio');
var _radio2 = _interopRequireDefault(_radio);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function YesNo(props) {
  return _react2.default.createElement(_radio2.default, Object.assign({}, props, {
    options: [{
      text: 'Yes',
      value: 'Y'
    }, {
      text: 'No',
      value: 'N'
    }]
  }));
}
exports.default = YesNo;